import type { ReactNode } from 'react';

/**
 * Müşteri detayının ortak kart yüzeyi (03.11.2026): her bölüm aynı başlık satırı, aynı iç boşluk,
 * aynı kenar. Başlık `aria-labelledby` ile bölüme bağlı. Metin çağıranın; burada gömülü metin yok.
 * Biçim: `detay.css` (`Detay` önekli sınıflar, başka ekranı etkilemez).
 */
export function DetayKart({
  kimlik,
  baslik,
  testKimligi,
  yan,
  children,
}: {
  kimlik: string;
  baslik: string;
  testKimligi?: string;
  yan?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section className="detay-kart" aria-labelledby={`${kimlik}-baslik`} data-testid={testKimligi}>
      <header className="detay-kart-ust">
        <h3 id={`${kimlik}-baslik`}>{baslik}</h3>
        {yan ?? null}
      </header>
      {children}
    </section>
  );
}
